import {testIdProps} from '@github-ui/test-id-props'

import type {Iteration} from '../../../../api/columns/contracts/iteration'
import {formatShortDate, intervalDateRange, isCurrentIteration} from '../../../../helpers/iterations'
import {formatISODateString} from '../../../../helpers/parsing'
import type {FieldAggregate} from '../../../../hooks/use-aggregation-settings'
import {useToday} from '../../../../hooks/use-today'
import {CurrentIterationLabel} from '../../../fields/iteration/iteration-label'
import {AggregateLabels} from '../../aggregate-labels'
import {SanitizedGroupHeaderText} from '../sanitized-group-header-text'
import styles from './iteration-group-header-label.module.css'

type Props = {
  iteration: Iteration
  rowCount: number
  hideItemsCount: boolean
  aggregates: Array<FieldAggregate>
  titleClassName?: string
}

export function IterationGroupHeaderLabel({iteration, rowCount, aggregates, hideItemsCount, titleClassName}: Props) {
  const title = iteration.titleHtml
  const dates = intervalDateRange(iteration)
  const today = useToday()
  const isCurrent = isCurrentIteration(today, iteration)

  return (
    <>
      <SanitizedGroupHeaderText titleHtml={title} className={titleClassName} />
      <AggregateLabels
        itemsCount={rowCount}
        aggregates={aggregates}
        hideItemsCount={hideItemsCount}
        counterClassName={styles.AggregateLabels}
      />
      {dates && (
        <span className={styles.iterationCode} {...testIdProps(`group-name-subtitle`)}>
          <time dateTime={formatISODateString(dates.startDate)}>{formatShortDate(dates.startDate)}</time>
          {` - `}
          <time dateTime={formatISODateString(dates.endDate)}>{formatShortDate(dates.endDate)}</time>
        </span>
      )}
      {isCurrent && <CurrentIterationLabel className={styles.CurrentIterationLabel} />}
    </>
  )
}
